export var AxisType;

(function (AxisType) {
  AxisType["HORIZONTAL"] = "horizontal";
  AxisType["VERTICAL"] = "vertical";
})(AxisType || (AxisType = {}));

export var PointHorizontalType;

(function (PointHorizontalType) {
  PointHorizontalType[PointHorizontalType["LEFT"] = 2] = "LEFT";
  PointHorizontalType[PointHorizontalType["CENTER"] = 0] = "CENTER";
  PointHorizontalType[PointHorizontalType["RIGHT"] = 3] = "RIGHT";
})(PointHorizontalType || (PointHorizontalType = {}));

export var PointVerticalType;

(function (PointVerticalType) {
  PointVerticalType[PointVerticalType["TOP"] = 8] = "TOP";
  PointVerticalType[PointVerticalType["CENTER"] = 0] = "CENTER";
  PointVerticalType[PointVerticalType["BOTTOM"] = 12] = "BOTTOM";
})(PointVerticalType || (PointVerticalType = {}));

export var PointType;

(function (PointType) {
  PointType[PointType["LEFT_TOP"] = 10] = "LEFT_TOP";
  PointType[PointType["LEFT"] = 2] = "LEFT";
  PointType[PointType["LEFT_BOTTOM"] = 14] = "LEFT_BOTTOM";
  PointType[PointType["TOP"] = 8] = "TOP";
  PointType[PointType["CENTER"] = 0] = "CENTER";
  PointType[PointType["BOTTOM"] = 12] = "BOTTOM";
  PointType[PointType["RIGHT_TOP"] = 11] = "RIGHT_TOP";
  PointType[PointType["RIGHT"] = 3] = "RIGHT";
  PointType[PointType["RIGHT_BOTTOM"] = 15] = "RIGHT_BOTTOM";
})(PointType || (PointType = {}));